var render, staticRenderFns
import script from "./AtomButton.vue?vue&type=script&lang=js&"
export * from "./AtomButton.vue?vue&type=script&lang=js&"
import style0 from "./AtomButton.vue?vue&type=style&index=0&id=2076c0fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076c0fa",
  null
  
)

export default component.exports